"use client";

import React from "react";
import { MapPin, Phone, Mail, Clock, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurPresenceInIndia() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-presence-in-india" ref={ref} className="relative w-full py-24 bg-background overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 lg:px-24">
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-16 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="relative flex justify-center items-center order-2 lg:order-1">
            <div className="relative w-full max-w-md aspect-[4/5] p-8">
              {}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-secondary/30 rounded-full blur-3xl -z-10" />
              
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1554289/img/india_map_minimalist.png" alt="Map of India showing Verifidie presence" className="w-full h-full object-contain opacity-90 drop-shadow-xl" />
              
              {}
              <div className="absolute top-[30%] left-[40%] size-3 bg-primary rounded-full animate-ping opacity-20" />
              <div className="absolute top-[30%] left-[40%] size-2 bg-primary rounded-full" />
              
              <div className="absolute top-[60%] left-[35%] size-3 bg-primary rounded-full animate-ping delay-300 opacity-20" />
              <div className="absolute top-[60%] left-[35%] size-2 bg-primary rounded-full" />
              
              <div className="absolute top-[45%] left-[65%] size-3 bg-primary rounded-full animate-ping delay-700 opacity-20" />
              <div className="absolute top-[45%] left-[65%] size-2 bg-primary rounded-full" />
            </div>
          </div>

          {}
          <div className="flex flex-col space-y-10 order-1 lg:order-2">
            <div className="space-y-4">
              <h2 className="text-4xl md:text-5xl font-serif text-foreground tracking-tight">
                Our Presence in India
              </h2>
              <p className="text-lg text-muted-foreground max-w-md leading-relaxed">
                Headquartered in India, we serve families and individuals across the nation and globally with discretion, clarity, and unwavering professionalism.
              </p>
            </div>

            <Card className="border-border/50 shadow-sm bg-card/50 backdrop-blur-sm">
              <CardContent className="p-8 space-y-8">
                {}
                <div className="flex items-start gap-5 group">
                  <div className="p-3 rounded-full bg-secondary text-primary shrink-0 group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                    <MapPin className="size-6" />
                  </div>
                  <div className="space-y-1">
                    <h3 className="font-medium text-foreground text-lg">Corporate Headquarters</h3>
                    <p className="text-muted-foreground leading-relaxed">
                      Verifidie<br />
                      India
                    </p>
                  </div>
                </div>

                {}
                <div className="flex items-start gap-5 group">
                  <div className="p-3 rounded-full bg-secondary text-primary shrink-0 group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                    <Phone className="size-6" />
                  </div>
                  <div className="space-y-1">
                    <h3 className="font-medium text-foreground text-lg">Secure Line</h3>
                    <p className="text-muted-foreground">
                      <Link to="tel:+911234567890" className="hover:text-primary transition-colors">+91 9718285422</Link>
                    </p>
                    <p className="text-xs text-muted-foreground/70">Available for confidential inquiries</p>
                  </div>
                </div>

                {}
                <div className="flex items-start gap-5 group">
                  <div className="p-3 rounded-full bg-secondary text-primary shrink-0 group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                    <Mail className="size-6" />
                  </div>
                  <div className="space-y-1">
                    <h3 className="font-medium text-foreground text-lg">Email Us</h3>
                    <p className="text-muted-foreground">
                      <Link to="mailto:contact@verifidie.in" className="hover:text-primary transition-colors">contact@verifidie.com</Link>
                    </p>
                  </div>
                </div>

                {}
                <div className="flex items-start gap-5 group">
                  <div className="p-3 rounded-full bg-secondary text-primary shrink-0 group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                    <Clock className="size-6" />
                  </div>
                  <div className="space-y-1">
                    <h3 className="font-medium text-foreground text-lg">Operating Hours</h3>
                    <p className="text-muted-foreground">
                      Monday to Saturday: 9am - 6pm
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <div className="pt-4">
              <Button asChild size="lg" className="rounded-full px-8 text-base h-12">
                <Link to="/GetClarityPage">
                  Schedule a Private Consultation <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}